import { MenuItem } from "@mui/material"
import { Info } from "@mui/icons-material"
import PropTypes from "prop-types"
import Tooltip from "components/material/tooltip"
import classNames from "classnames"

export function FilterOption({
  option: {
    label: optionLabel,
    tooltip = "",
    value,
  },
  disabled,
  ...props
}) {
  const label = <span
    className={classNames("filter-option-label", { "segment-disabled-label": disabled && tooltip })}
    aria-disabled={disabled}
    role="option"
    aria-selected={false}
  >
    {optionLabel}
    {disabled && tooltip && (
      <span
        className="segment-disabled-icon"
        aria-label={`More information about ${optionLabel}`}
        role="tooltip"
      >
        <Tooltip title={tooltip}>
          <Info fontSize="small" />
        </Tooltip>
      </span>
      )}
  </span>

  return (
    <MenuItem
      key={value}
      disabled={disabled}
      value={value}
      {...props}
    >
      {label}
    </MenuItem>
  )
}

FilterOption.propTypes = {
  option: PropTypes.shape({
    label: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    tooltip: PropTypes.string,
    value: PropTypes.string.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
}
